/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from "react";
import cx from "classnames";

import { isEmpty } from "@swiggy-private/core-ui";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { IOptionItem } from "../types";

import { CircleTickIcon } from "@cart-ui/widgets/tick-icon";

import { PLACEHOLDERS } from "@cart-ui/constants/OfferBundle";
import { OFFER_BUNDLE } from "@swiggy-private/cart-test-ids";

import { Subtitle } from "../styles/OfferBundleHalfCard.styled";
import styles from "../styles/OfferBundleHalfCard.scss";

const OptionItem = ({ title, attribute_values, sub_title, badge_info, isSelected, onSelect }: IOptionItem) => {
    const contentTitle = useMemo(() => {
        if (!isEmpty(attribute_values?.base_price) && title.includes(PLACEHOLDERS.BASE_PRICE)) {
            return title.replace(
                PLACEHOLDERS.BASE_PRICE,
                `<span class=${styles.strikethrough}>${attribute_values?.base_price}</span>`,
            );
        }
        return title;
    }, [title, attribute_values]);

    const badgeTextColor = useMemo(() => (isSelected ? "background_Primary" : "text_Highest_Emphasis"), [isSelected]);

    return (
        <div className={styles.wrapper} data-testid={OFFER_BUNDLE.OPTION_ITEM}>
            {badge_info?.text && (
                <div
                    className={cx(styles.badgeInfo, {
                        [styles.badgeInfoSelected]: isSelected,
                    })}
                >
                    <Text variant="V2.body1.neutral.regular" color={badgeTextColor}>
                        {badge_info?.text}
                    </Text>
                </div>
            )}
            <div
                className={cx(styles.optionItem, {
                    [styles.optionItemSelected]: isSelected,
                })}
                onClick={onSelect}
            >
                <div className={styles.content}>
                    {!isEmpty(contentTitle) && (
                        <Text
                            variant="V2.body1.neutral.bold"
                            color="text_Highest_Emphasis"
                            dangerouslySetInnerHTML={{ __html: contentTitle }}
                        />
                    )}
                    {!isEmpty(sub_title) && (
                        <Subtitle variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
                            {sub_title}
                        </Subtitle>
                    )}
                </div>
                <div>{isSelected && <CircleTickIcon />}</div>
            </div>
        </div>
    );
};

export default OptionItem;
